import { useState } from 'react';
import { connect } from 'react-redux';
import { Col, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';

import { FormPage } from '../../core/containers';
import DataTable from '../../core/components/datatable/DataTable';
import VehicleNumberInput from '../../core/components/forms/VehicleNumberInput';
import { numberValidationSchema } from '../validation';
import * as actions from '../store/actions';
import Form from '../../core/components/forms/Form';
import SubmitButton from '../../core/components/forms/SubmitButton';
import * as URL from '../../../lib/router/url';
import { useComponentWillUnmount } from '../../core/hooks';

interface VehicleSearchByNumberProps {
  data?: unknown[];
  findVehicleByNumber?(...args: unknown[]): unknown;
  clearFoundVehicles?(...args: unknown[]): unknown;
  // lookupError?: object;
  loading?: boolean;
}

const VehicleSearchByNumber = (props: VehicleSearchByNumberProps) => {
  const {
    // lookupError,
    data,
    findVehicleByNumber,
    loading,
    clearFoundVehicles,
  } = props;

  const [isLoading, setLoading] = useState(false);

  const columns = [
    {
      title: 'Номер',
      name: 'number',
      getCellValue: (row) => (
        <Link to={ `${ URL.URL_VEHICLE_VIEW }/${ row.id }` }>
          { row.number }
        </Link>
      ),
    },
    { title: 'Марка', name: 'makeTitle' },
    { title: 'Модель', name: 'modelTitle' },
    { title: 'vin', name: 'vin' },
    {
      title: 'Корпоративный',
      name: 'isCorporate',
      getCellValue: (row) => (
        row.isCorporate ? 'Да' : ''
      ),
    },
  ];

  const handleSearch = async (values) => {
    const { number } = values;

    if (!number) return;

    setLoading(true);
    try {
      await findVehicleByNumber(number);
    } finally {
      setLoading(false);
    }
  };

  useComponentWillUnmount(
    () => {
      clearFoundVehicles();
    }
  );

  return (
    <FormPage
      header='Поиск Автомобиля'
      showSubmitButton={ false }
    >
      <Form
        loading={ isLoading }
        validationSchema={ numberValidationSchema }
        initialValues={ { phoneMobile: '' } }
        // error={ lookupError }
        disableSubmitButton={ false }
        onSubmit={ handleSearch }
      >
        { ({ handleSubmit }) => (
          <>
            <Row>
              <Col lg={ 10 }>
                <VehicleNumberInput
                  name='number'
                  placeholder='Гос.номер'
                  onKeyUp={ (e) => {
                    if (e.key === 'Enter') handleSubmit();
                  } }
                />
              </Col>

              <Col lg={ 2 }>
                <SubmitButton text='Найти' />
              </Col>
            </Row>
            { /* <Row>
              <Col lg={ { span: 4, offset: 4 } }>
                <h5>{ lookupError?.message }</h5>
              </Col>
            </Row> */ }
            <Row>
              <Col md={ 12 }>
                { ((!!data) && (data.length > 0)) && (
                  <DataTable
                    loading={ loading }
                    data={ data }
                    columns={ columns }
                    // onRowClick={ handleRowClick }
                    hidePagination
                    hideToolbar
                    localSorting
                  />
                ) }
              </Col>
            </Row>
          </>
        ) }
      </Form>
    </FormPage>
  );
};

const mapStateToProps = (state) => ({
  loading: state.vehicles?.loading,
  data: state.vehicles?.foundVehicles,
  lookupError: state.vehicles?.error,
});

const mapDispatchToProps = (dispatch) => ({
  findVehicleByNumber: (payload) => dispatch(actions.findVehicleByNumber(payload)),
  clearFoundVehicles: (payload) => dispatch(actions.clearFoundVehicles(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(VehicleSearchByNumber);
